import { concatMap, from, shareReplay, take, tap } from 'rxjs';
import { apiService } from '@core/services/Api.service';
import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { tokenService } from '@core/services/Token.service';

class RefreshTokenMutation {
  public refreshToken$() {
    return tanstackQueryService
      .mutation({
        mutationFn: () => tokenService.refreshToken()
      })
      .pipe(
        concatMap(({ mutate }) => from(mutate())),
        shareReplay({
          bufferSize: 1,
          refCount: true
        }),
        take(1),
        tap({
          next: ({ data: tokens }) => {
            tokenService.setTokens(tokens);
            apiService.api.defaults.headers.common.Authorization = `Bearer ${tokens.accessToken}`;
          }
        })
      );
  }
}

const refreshTokenMutation = new RefreshTokenMutation();

export { refreshTokenMutation };
